<template>
  <div class="public-shell">
    <AppHeader />

    <UMain class="public-content">
      <slot />
    </UMain>

    <LazyAppFooter :hydrate-on-visible="{ rootMargin: '300px' }" />
  </div>
</template>
